<div class="card card-w-title top-level-card">
    <h1>Container Search</h1>
    <page-header title="Container Search" [showSpinner]="isLoading" [error]="error"></page-header>
    <container-table></container-table>
</div>
